/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HeaderRequest,
  HeaderResponse,
  HeadersRequest,
  PageResponseHeaderResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Headers<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags header-controller
   * @name AddHeader
   * @request POST:/headers
   * @secure
   * @response `200` `HeaderResponse` OK
   */
  addHeader = (data: HeaderRequest, params: RequestParams = {}) =>
    this.request<HeaderResponse, any>({
      path: `/headers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags header-controller
   * @name ListHeaders
   * @request POST:/headers/getHeaders
   * @secure
   * @response `200` `PageResponseHeaderResponse` OK
   */
  listHeaders = (data: HeadersRequest, params: RequestParams = {}) =>
    this.request<PageResponseHeaderResponse, any>({
      path: `/headers/getHeaders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags header-controller
   * @name ShowHeader
   * @request GET:/headers/{headerId}
   * @secure
   * @response `200` `HeaderResponse` OK
   */
  showHeader = (headerId: string, params: RequestParams = {}) =>
    this.request<HeaderResponse, any>({
      path: `/headers/${headerId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags header-controller
   * @name UpdateHeader
   * @request PATCH:/headers/{headerId}
   * @secure
   * @response `200` `HeaderResponse` OK
   */
  updateHeader = (
    headerId: string,
    data: HeaderRequest,
    params: RequestParams = {},
  ) =>
    this.request<HeaderResponse, any>({
      path: `/headers/${headerId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
